import React from 'react';
import "./Header.css"
import {Link} from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import {useStateValue} from "./StateProvider";
import {auth} from "./firebase";
function Header() {
    const[{basket,user}]= useStateValue();
const login = () =>{
    if(user){
      auth.signOut();
        }
      }
    return( <nav className="header">
        <Link to="/">
        <img className = "header__logo" src="http://pngimg.com/uploads/amazon/amazon_PNG11.png" alt="">

        </img>
        </Link>


        <div className="header_search">
        <input type="text" className="header__searchInput"/>
        <SearchIcon className="header__searchIcon" /> 
        </div>
        

        <div className = "header_nav">
        <Link to ={!user && "/login"} className="header__link">
        <div onClick={login} className="header_option">
        <span className="header__optionline1">Hello {user?.email}</span>
        <span className="header__optionline2">{user ? 'Sign Out' : 'Sign in'}</span>
        </div>
        </Link>
        <Link to ="/" className="header__link">
        <div className="header_option">
        <span className="header__optionline1">
          Returns
        </span>
        <span className="header__optionline2" >
           Orders
        </span>
        </div>
        
      
        </Link>
        <Link to ="/login" className="header__link">
        <div className="header_option">
        <span className="header__optionline1">
            Your
        </span>
        <span className="header__optionline2">
          Prime
        </span>
        </div>
        
      
        </Link>
        </div>

        <Link to="/checkout" className="header__link">
        <div className="header__optionbasket">
          <ShoppingBasketIcon />
<span className="header__optionline2 header__bascketcount">{basket?.length}</span> 
        </div>
        </Link>
</nav>
        );
}

export default Header;
